import styled from "styled-components";

export const Container = styled.div`
  display: none;

  @media print {
    display: block;
    page-break-after: always;
    width: 100%;
  }
`;

export const IntroText = styled.div`
  text-align: center;
`;

export const UterumImage = styled.img`
  width: 480px;
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
`;

export const UterumImageContainer = styled.div`
  height: 400px;
`;
